import { HttpClient } from "@angular/common/http";
import { Endpoints } from "src/app/shared/config/endpoints";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/app.state";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LinkedInService {
  private orgId: number;
  private baseUri = this.endpoints.linkedinServiceUrl;

  postToView = new BehaviorSubject<any>({});
  postToReply: any = new BehaviorSubject<any>({});
  repliedPost: any = new BehaviorSubject<string>("");

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgId = info.organization.id;
    });
  }

  fetchOrganizationPages(): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}`);
  }

  login(code: string): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/setup/connect`, {
      code,
      org_id: this.orgId,
    });
  }


  fetchPageSubscriptions(organization: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/pages/setup/subscriptions/${this.orgId}/${organization}`
    );
  }

  updateOrganizationPages(data: any): Observable<any> {
    return this.http.put(
      `${this.baseUri}/pages/active/${this.orgId}/${data.organization}`,
      { ...data }
    );
  }

  disconnectOrganizationPage(pageId: any): Observable<any> {
    return this.http.delete(
      `${this.baseUri}/pages/setup/disconnect/${this.orgId}/${pageId}`
    );
  }

  fetchOrganizationPagePosts(pageId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/feeds/read/filter?orgId=${this.orgId}&pageId=${pageId}`
    );
  }

  subscribeToApp(data: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/setup/subscribe`, {
      org_id: this.orgId,
      ...data,
    });
  }

  fetchPagePostsWithComments(): Observable<any> {
  return this.http.get(`${this.baseUri}/pages/comments/${this.orgId}`);
  }

  fetchMentions(): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/mentions/${this.orgId}`);
}

  replyToComment(commentId: string, message: string): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/response/comment`, {
        org_id: this.orgId,
        commentId,
        message
    });
}


  
}
